<template>
  <div class="row">
    <div class="col-sm-12 col-md-8 mb-0">
      <title-bread-crumb :page="page" />
    </div>
    <div
      class="col-sm-12 col-md-4 d-flex justify-content-end align-items-center actions text-right"
    >
      <!-- acciones comunes, no deberia agregar otras..., mejor rendererize dinamicamente -->
      <action-button
        v-if="onReturn"
        class="mx-2"
        i="fas fa-arrow-circle-left"
        text="Regresar"
        variant="outline-success"
        @click="onReturn"
      />

      <action-button
        v-if="onAdd"
        class="mx-2"
        i="fas fa-file-plus pr-1"
        text="Añadir"
        variant="success"
        @click="onAdd"
      />

      <action-button
        v-if="onSave"
        class="mx-2"
        i="fas fa-save pr-1"
        text="Guardar"
        variant="success"
        @click="onSave"
      />

      <div v-for="action in actions" :key="action.name">
        <component
          :is="action.component || 'ActionButton'"
          v-if="action.visible || action.visible == null"
          :class="action.class || 'mx-2'"
          :i="action.icon"
          :text="action.text"
          :variant="action.variant"
          @click="$eventHandler(action.click)"
        />
      </div>
      <slot />
    </div>
    <div class="col-12 p-0">
      <div class="dropdown-divider mt-0 pb-2 w-100 mb-4" />
    </div>
  </div>
</template>

<script>
//TODO: cambiar ruta de componente cuando sea migrado a shared
import ActionButton from '@/components/common/ActionButton';
import TitleBreadCrumb from './TitleBreadcrumb';

//Puedes Renderizar las acciones dinamicamente, y por defecto hay algunas opciones a las que se les puede bindear directamente una
// funcion; no deberias modificar este archivo para agregar otras opciones como botones, dropdowns, etc, ya que esto no seria
//escalable
export default {
  components: {
    TitleBreadCrumb,
    ActionButton,
  },
  props: {
    page: {
      type: Object,
      default: () => ({}),
    },
    actions: {
      type: Array,
      default: () => [],
    },
    onReturn: {
      type: Function,
      default: undefined,
    },
    onSave: {
      type: Function,
      default: undefined,
    },
    onAdd: {
      type: Function,
      default: undefined,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

$greenColor: map_get($colors, 'green');

.actions {
  @media screen and (max-width: 765px) {
    margin-left: 2%;
  }

  @media screen and (max-width: 870px) {
    button {
      margin-bottom: 10px;
    }
  }
}
</style>
